import { useContext, useEffect, useState } from "react";
import PointsTable from "../../common/pointsTable/PointsTable";
import { GET } from "../../utils/fetchUtil";
import Loader from "../../common/loader/Loader";
import { Column, Row } from "../../common/columns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../common/theme/ThemeContext";

const RequestPointsPage = () => {
  const theme = useContext(ThemeContext);
  const [response, setResponse] = useState({
    activities: [],
    license: "",
    institution: "",
    branch: "",
    network: "",
  });

  useEffect(() => {
    GET(
      "/score",
      (data) => {
        setResponse({
          activities: data.activities,
          license: data.license,
          institution: data.institution,
          branch: data.branch,
        });
      },
      (error) => {
        setResponse({ network: "500" });
      }
    );
  }, []);

  if (response.license !== "" && response.network !== "500") {
    return (
      <PointsTable
        institution={response.institution}
        branch={response.branch}
        license={response.license}
        activities={response.activities}
      />
    );
  } else if (response.network === "500") {
    return (
      <div>
        <Row>
          <Column className="has-text-centered has-text-weight-bold mb-5 pr-0 navi-exception">
            <FontAwesomeIcon
              size="3x"
              className={`has-text-${theme.purpleWarning}`}
              style={{ fontSize: "8em" }}
              icon={faExclamationTriangle}
            />
          </Column>
        </Row>
        <Row className="mt-5">
          <Column className="has-text-centered has-text-weight-bold mb-5 pr-0 navi-exception is-size-4">
            Interna pogreška poslužitelja. Molimo kontaktirajte nas kako bi mogli otkloniti problem.
          </Column>
        </Row>
      </div>
    );
  } else {
    return <Loader size="8x" />;
  }
};

export default RequestPointsPage;
